import React from 'react'
import PropTypes from 'prop-types'
import { Link, Route } from 'react-router-dom'

import './Header.css'

const Header = ({logo, title, instagram, etsy}) => {
  return (
    <header className='Header'>
      <div className='container flex'>
        <div className='col'>
          <Link className='logo' to='/'><img src={logo} alt={title} /> </Link>
        </div>
        <div className='col nav'>
          <ActiveLink to='/gallery/' label='Gallery' />
          <ActiveLink to='/' label='About' activeOnlyWhenExact />
          <ActiveLink to='/contact/' label='Contact' />
        </div>
        <div className='Header--socials'>
          { instagram && <a href={instagram}><i className='fa fa-instagram' /></a> }
          { etsy && <a href={etsy}><i className='fa fa-etsy' /></a> }
        </div>
      </div>
    </header>
  )
}

const ActiveLink = ({ label, to, activeOnlyWhenExact }) => (
  <Route path={to} exact={activeOnlyWhenExact} children={({ match }) => (
    <Link className={match ? 'active' : ''} to={to}>{label}</Link>
  )} />
)

Header.propTypes = {
  logo: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired
}
export default Header



// WEBPACK FOOTER //
// ./src/Header/Header.js